"use strict";

var _toConsumableArray = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _classCallCheck = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var firestore_1 = require("firebase/firestore");

var functions_1 = require("../../functions");

var Espace_1 = __importDefault(require("../../Model/Espace"));

var Channel = /*#__PURE__*/function (_Espace_1$default) {
  _inherits(Channel, _Espace_1$default);

  var _super = _createSuper(Channel);

  function Channel(props) {
    _classCallCheck(this, Channel);

    return _super.call(this, _objectSpread(_objectSpread({}, props), {}, {
      collectionName: 'channels',
      orderDirection: props.orderDirection || 'desc',
      orderField: props.orderField || 'datetime'
    }));
  }

  _createClass(Channel, [{
    key: "watchWorkflowRuns",
    value: function watchWorkflowRuns(docId, _next, options) {
      var _a;

      var constraints = [];
      constraints = (0, functions_1.updateConstraints)(constraints, {
        orderDirection: 'desc',
        orderField: 'created_at',
        wheres: options === null || options === void 0 ? void 0 : options.wheres
      });
      constraints.push((0, firestore_1.limit)((_a = options === null || options === void 0 ? void 0 : options.limit) !== null && _a !== void 0 ? _a : parseInt(String(process.env.GATSBY_INNEDIT_WATCH_LIMIT), 10) || 250));
      return (0, firestore_1.onSnapshot)((0, firestore_1.query).apply(void 0, [(0, firestore_1.collection)(this.getCollectionRef(), docId, 'workflowRuns')].concat(_toConsumableArray(constraints))), {
        next: function next(querySnaphot) {
          _next(querySnaphot.docs.map(function (d) {
            return _objectSpread({
              id: d.id
            }, d.data());
          }));
        }
      });
    }
  }]);

  return Channel;
}(Espace_1.default);

exports.default = Channel;